import React from 'react';
import { motion } from 'framer-motion';
import { skillGroups } from '../../data/skills';
export function SkillsGrid() {
  return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-167" data-mp="14otbapuypreu">
      {skillGroups.map((group, index) => <motion.div key={group.category} initial={{
      opacity: 0,
      y: 14
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-10% 0px'
    }} transition={{
      duration: 0.4,
      delay: index * 0.06,
      ease: [0.23, 1, 0.32, 1]
    }} className="flex flex-col rounded-xl border border-slate-200 bg-white p-7" data-id="element-168" data-mp="qrmtoylz5yr7" data-mpi={index}>
          <h3 className="font-heading text-base font-semibold leading-snug text-navy" data-id="element-169" data-mp="735pt001oti3">{group.category}</h3>
          <ul className="mt-5 space-y-3" data-id="element-170" data-mp="c0xhbsws2dlr">
            {group.skills.map(skill => <li key={skill} className="flex items-start gap-2.5 text-sm leading-relaxed text-charcoal" data-id="element-171" data-mp="3u7lnzn7h78tj">
                <span className="mt-1.5 h-1 w-1 shrink-0 rounded-full bg-brandgreen" aria-hidden="true" data-id="element-172" data-mp="2zg6aoy8923x" />
                {skill}
              </li>)}
          </ul>
        </motion.div>)}
    </div>;
}